<template>
  <div class="aside">
      <slot></slot>
  </div>
</template>

<script>
export default {
    name: 'g-aside'
}
</script>

<style lang="scss" scoped>

</style>
